import { UserRole } from '../callMsGroup';

const REAL_KEY     = '__role_real';
const OVERRIDE_KEY = '__role_override';

export function saveRealRole(role: UserRole) {
    sessionStorage.setItem(REAL_KEY, role);
}

export function getRealRole(): UserRole | null {
    return sessionStorage.getItem(REAL_KEY) as UserRole | null;
}

export function setRoleOverride(role: UserRole | null) {
    if (role) sessionStorage.setItem(OVERRIDE_KEY, role);
    else sessionStorage.removeItem(OVERRIDE_KEY);
}

export function getRoleOverride(): UserRole | null {
    return sessionStorage.getItem(OVERRIDE_KEY) as UserRole | null;
}

export function getEffectiveRole(realRole: UserRole): UserRole {
    if (realRole !== 'superadmin') return realRole;
    return (getRoleOverride() as UserRole) ?? realRole;
}

export function isImpersonating(): boolean {
    return getRealRole() === 'superadmin' && getRoleOverride() !== null;
}
